// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2WeRg","amount":"Amount_amount__6hetU","tip":"Amount_tip__37NQo","tipHeader":"Amount_tipHeader__qQ1Ve","tipsWrap":"Amount_tipsWrap__hYgXF"};